module.exports = __webpack_public_path__ + "img/switch.7fb8fdf9.svg";